import { StatusTypeEnum } from "../../Enum/pdf-file-info-status.enum";

export class StatusSharedDto {
    id: number;
    // status: StatusTypeEnum;
}